import { EnvironmentOutlined, InfoCircleOutlined } from '@ant-design/icons'
import { Flex, Space } from 'antd'
import Map from 'app/components/Modules/Map/Map'
import { Link, useNavigate } from 'react-router-dom'

import { MemberProps } from '../../../components/Core/convention'
import KInfoRow from '../../../components/Modules/DataDisplay/KInfoRow'
import Button from '../../../components/UI-Elements/General/Button'
import { RecordType } from '../../../constants/GlobalTypes'
import { normalizeAddressSummary } from '../../../lib/apollo/normalizers/Rental'
import useTranslation from '../../../lib/hooks/useTranslation'
import { Routes } from '../../../routes/Routes'

export default function ProjectCard({ member }: MemberProps<ILineItem>) {
  const navigate = useNavigate()
  const { tButtonTitle } = useTranslation({ recordType: RecordType.rental })

  if (!member) return null

  const { project } = member
  const location = [
    {
      id: project?.id,
      longitude: project?.longitude,
      latitude: project?.latitude
    }
  ]

  const onRentalClick = () => {
    navigate(Routes.Rental.member(member.rental_id.toString()).show)
  }

  return (
    <>
      <h6 className={'mb-0'}>
        <Link id={project.id.toString()} to={Routes.Project.member(project?.id).show}>
          <div className="d-flex">{project?.name}</div>
        </Link>
      </h6>
      <div className={'py-3'}>
        <Map
          collection={location}
          height="200px"
          options={{
            streetViewControl: false,
            mapTypeControl: false,
            zoomControl: false,
            fullscreenControl: false,
            panControl: false
          }}
        />
      </div>

      <Space direction="vertical" className="py-1 full-width">
        <KInfoRow
          recordType={RecordType.project}
          icon={<EnvironmentOutlined />}
          attribute="address"
          value={normalizeAddressSummary(project.address)}
        />
        <Flex justify="space-between" align="center" wrap>
          <KInfoRow
            recordType={RecordType.line_item}
            icon={<InfoCircleOutlined size={16} />}
            attribute="rental_code"
            value={<div>{member.rental_code}</div>}
          />
          <Button type="secondary" onClick={onRentalClick}>
            {tButtonTitle({ id: 'link' })}
          </Button>
        </Flex>
      </Space>
    </>
  )
}
